
const financeService = "/finance-service";
const auth = "/auth";
const supportServices = "/support-service";
const apiServices = "/api-service";
const consumerService = "/consumer-service";
const tenantService = process.env.NODE_ENV === "development"?"/tenantService":"/tenant-service";
const travelService = ""

export default {
 BASE_URL_TRAVEL: process.env.NODE_ENV === "development"?"":'https://api.tripscroll.com',

    BASE_URL: "",
    //CUSTOMER_BASE_URL: "https://customer.pay2mobiles.com",
    CUSTOMER_BASE_URL: "https://customer.pay2mobiles.com",
  //TENANT_BASE_URL:"https://crm.pay2mobiles.com/finance-service",
  login: {

      GET_USER_ACCOUNT: financeService+"/api/user/account",
      FORGET_PASSWORD_GENERATE_OPT: auth+"/api/user/account/reset-password/init",
      USER_LOGIN: auth+"/api/authenticate",
      RESET_PASSWORD: auth+"/api/user/account/reset-password/finish",
      USER_COUNT:auth+"/api/user/count",
      USER_LOGIN_V2: auth + "/api/authenticate/v2",
      USER_LOGIN_OTP_VERIFY: auth + "/api/authenticate/otp",
       FORGET_PASSWORD_GENERATE_OPT:auth + "/api/user/account/reset-password/init",
       RESET_PASSWORD: auth + "/api/user/account/reset-password/finish",
      

  },
  admin:{
    EDIT_ADMIN_USER: financeService+"/api/user/account",
    CHANGE_PASSWORD : auth+"/api/user/account/change-password"
 
  },
  users:{
    GET_USER_LIST:financeService+"/api/users/list",
    ADD_USER:financeService+"/api/users",
    EDIT_USER:financeService+"/api/update-users",
    DELETE_USER:financeService+"/api/users",
    ONBORDING_USER:financeService+"/api/aeps/onboarding",
    OTP_VERIFY:financeService+"/api/aeps/verify/otp",
    ADD_BANK_DETAILS:financeService+"/api/kyc/create",
    VERYFY_AADHAR:financeService+"/api/aeps/onboarding",
    USER_SEARCH:financeService+"/api/users/search",
    USER_PPACKAGE_MAPPING:financeService+"/api/user/package/mapping",
    USER_STATUS : financeService+"/api/users/status",
    DIOSM_VERIFY_PAN : financeService+"/api/kyc/verify/pan",
    DIOSM_VERIFY_PAN_CONFIRM  : financeService+"/api/kyc/confirm/pan",
    DIOSM_AADHAR_KYC : financeService+"/api/kyc/verify/aadhar/init",
    DIOSM_AADHAR_OTP_VERIFY : financeService+"/api/kyc/verify/aadhar/finish",
  },
 Overview :{ 
MAIN_TREE_BALANCE :'/finance-service/api/dashboard/total/main/balance',
AEPS_TREE_BALANCE:financeService+"/api/dashboard/total/aeps/balance",
TOTAL_USERS:financeService+"/api/dashboard/total/users",
SETTLEMENT_BALANCE:financeService+"/api/dashboard/settlement/balance",
LIVE_BALANCE:financeService+"/api/dashboard/live/balance",
SERVICE_DETAILS:financeService+"/api/dashboard/service/details",
OUTSTANDING_DETAIL:financeService+"/api/outstanding-detail",
TOTAL_PAYIN_PAYOUT:financeService+"/api/dashboard/transaction/details",
VIEW_LIVE_BALANCE:financeService+"/api/dashboard/user/wallet/balance",

 },
  

  Operators:{
    OPERATORS_LIST:financeService+"/api/operator/filter?",
  },
  transactions:{

    TRANSACTION_LIST:financeService+"/api/report/admin/transactions",
    CHECK_TRANSACTION_STATUS:financeService+"/api/upi/verify-transaction",
    ADDMONEY_TRANSACTION_REFUND:financeService+"/api/pg/initiate/refund",
  },

wallet:{
  WALLET_SUMMARY:financeService+"/api/wallet/filter/transactions",
  CHECKPAYBACK_STATUS:financeService+"/api/wallet/transaction",
},
ADD_DEBIT_CREDIT:{
    CREATE_DEBIT_CREDIT:"finance-service/payback/create",
    USER_DETAIL:financeService+"/api/users/search",
    DEBIT_CREDIT_LIST:financeService+"/payback/list",
    DEBIT_CREDIT_APPROVE:"finance-service/payback/approve"
},
SETTING:{
  CHANGE_PASSWORD:financeService+"/api/user/account/change-password",
  
},
Service:{
  SERVICE_LIST:financeService+"/api/service/filter",
  //AEPS_BANK_LIST: financeService+'/api/aeps/bank/list',
 AEPS_BANK_LIST: financeService+'/api/kyc/bank/list',
},
UpdateService:{
  UPDATE_SERVICE:financeService+"/api/service/update"
},

roleAndPermission:{

  Role_Permission:auth+"/api/frontend/hierarchy/permissions",
  ALL_PERMISSION:auth+"/api/frontend/hierarchy/permissions",
 UPDATE_PERMISSION: auth+"/api/frontend/update/permissions"
  

},
package :{
  PACKAGE_UPDATE:financeService+"/api/user/package/update/packageDetailsService",
  PACKAGE_PRICE_CONFIGURATION_UPDATE:financeService+"/api/user/package/update/priceConfiguration",
  PACKAGE_LST:financeService+"/api/user/package/list/detail",
  CREATE_PACKAGE:financeService+"/api/user/package/create/packageDetailsAndService",
  CREATE_PACKAGE_SERVICES:financeService+"/api/user/package/create/priceConfiguration" ,
  PACKAGE_CODE_LIST:financeService+"/api/user/package/code/list",
  PACKAGE_CODE_DETAIL:financeService+"/api/user/package/code/detail",
  PACKAGE_ROUTE: financeService+"/api/service/routes",
  CONFIG_SERVICE: financeService+"/api/upi/config-upi?clientCode=" ,
    

},  



ticketManagement :{
   GET_TICKET_LIST : supportServices+"/admin/ticket/list",
   CREATE_TICKET : supportServices +"/admin/ticket/create",
   UPDATE_TICKET : supportServices +"/admin/ticket/update",
   GET_CATEGORY : supportServices + "/admin/ticket/category",
   GET_STATUS : supportServices + "/admin/ticket/status",
   GET_REQUESTTYPE : supportServices + "/admin/ticket/request-type",
   GET_PRIORITY : supportServices + "/admin/ticket/priority",
},
chatData: {
  GET_MESSAGE: supportServices+"/chatbox/message",
  SEND_MESSAGE: supportServices+"/chatbox/save",
},
sendMoney:{
  SEND_MONEY_URL: financeService+'/api/payout',
  VERIFY_ACCOUNT: financeService+"/api/dmt/beneficiary/verify",
},
api: {
  GET_API_USER_LIST: apiServices+`/user/list`,
  CREATE_VENDOR_USER: apiServices+`/user/create`,
  VENDOR_TRANSACTION_LIST: apiServices+`/transaction/list`,
  VENDOR_FUND_REQUEST_LIST: apiServices+"/fund/wallet/list",
  VENDOR_FUND_REQUEST_APPROVAL: apiServices+"/fund/wallet/approval",
},


inventoryManage:{
  CREATE_INVENTORY:financeService+`/api/inventory/save`,
  ADD_POS:financeService+`/api/inventory/addDevice`,
  GET_INVENTORY_DETAIL:financeService+`/api/inventory/detail`,
  UPDATE_INVENTORY: financeService+`/api/inventory/update`,
  DELETE_INVENTORY:financeService+`/api/inventory/delete`,
  ASSIGN_DEVICE : financeService+`/api/inventory/assign`,
  ASSIGNED_DEVICE_LIST : financeService+`/api/inventory/mappingList`,
  UNASSIGNED_DEVICE : financeService + `/api/inventory/unassigned`,
},
cmd:{
  ADD_CARD:financeService + '/cdm/card/save',
  CARD_lIST:financeService + '/cdm/card/list',
  ADD_BULK_CARD:financeService +'/cdm/card/add/inventory',
  CDM_UPDATE_STATUS:financeService +'/cdm/card/update/status',
  ASSIGNED_CDM_LIST:financeService +'/cdm/card/assigned/list',
  MAPP_CDM_CARD:financeService +'/cdm/card/assign',
  CDM_UPDATE_MAPPED_STATUS:financeService +'/cdm/card/mapping/update/status',
},
dqr:{
  ADD_DQR_CARD:financeService + '/dqr/addDevice',
  DQR_LIST:financeService + '/dqr/list',
  ADD_BULK_DQR:financeService +'/dqr/add/inventory',
  DQR_UPDATE_STATUS:financeService +'/dqr/update/status',
  ASSIGNED_DQR_LIST:financeService +'/dqr/assigned/list',
  MAPP_DQR_CARD:financeService +'/dqr/assign',
  DQR_UPDATE_MAPPED_STATUS:financeService +'/dqr/mapping/update/status',
},
travel:{
  VIEW_TRAVEL_WALLET_BALANCE:"/travel/admin/feed/wallet/balance",
  FETCH_COUNTRY:"/travel/country/all",
  HOTEL_LIST:'/travel/admin/hotel/list',
  CITY_LIST:'/travel/admin/city/list',
  COUNTRY_LIST:'/travel/admin/country/list',
  AUTO_SUGGEST:'/travel/admin/suggest',
  INFO_CITY:"/travel/admin/city",
  INFO_HOTEL:"/travel/admin/hotel",
  INFO_COUNTRY:"/travel/admin/country",
  INFO_IMAGE:"/travel/admin/hotel/image/get",
  ADD_IMAGE:"/travel/admin/hotel/image/create",
  UPDATE_IMAGE_STATUS:"/travel/admin/hotel/image",
// hotel
ADD_HOTEL:"/travel/admin/hotel/create",
ADD_CITY:"/travel/admin/city/create",
ADD_COUNTRY:"/travel/admin/country/create",
UPDATE_COUNTRY:"/travel/admin/country/update",
UPDATE_CITY:"/travel/admin/city/update",
UPDATE_HOTEL:"/travel/admin/hotel/update",
UPDTAE_IMAGE:"/travel/admin/hotel/image/update",
UPDATE_HOTEL_STATUS:"/travel/admin/hotel",
UPDATE_CITY_STATUS:"/travel/admin/city",
UPDATE_COUNTRY_STATUS:"/travel/admin/country",
//airline
AIRLINE_LIST:"/travel/admin/airline/list",
UPDATE_AIRLINE_STATUS:"/travel/admin/airline",
UPDATE_AIRLINE:"/travel/admin/airline/update",
AIRLINE_INFO:"/travel/admin/airline/",
ADD_AIRLINE:"/travel/admin/airline/create",

AIRPORT_LIST:"/travel/admin/airport/list",
UPDATE_AIRPORT_STATUS:"/travel/admin/airport",
AIRPORT_INFO:"/travel/admin/airport",
UPDATE_AIRPORT:"/travel/admin/airport/update",
ADD_AIRPORT:"/travel/admin/airport/create",
BOOKING_LIST:"/travel/admin/booking/flight/all"

},
addFundBulk:{
  UPLOAD_FILE:financeService +"/api/fund/bulk/upload",
  GET_FILE_LISTING:financeService +"/api/fund/data/list",
  GET_FILE_DATA:financeService +"/api/fund/data/details",
  PROCESS_FUND:financeService +"/api/fund/process"

},
b2bManageKyc:{
GET_KYC_DETAILS:auth+"/api/onboarding/kyc/details?userId=",
KYC_APPROVE:auth+"/api/mgmt/onboarding/kyc/approve",
KYC_REJECT:auth+"/api/mgmt/onboarding/kyc/reject",
KYC_STATUS:auth+"/api/mgmt/onboarding/kyc/status",
PARENT_DETAILS:auth+"/api/user",
PARENT_UPDATE:financeService+"/api/user/update/parent",
BANK_APPROVE:financeService+"/api/kyc/bank/approve",
BANK_REJECT:financeService+"/api/kyc/bank/reject",
GET_BANK_DETAILS:financeService+"/api/kyc/beneficiary/detail",

},
referralUsers:{
 ADD_REFERRAL_USER:auth+"/api/user/add",
 REFERRAL_USER_LIST:auth+"/api/user/list",
},

customer:{
  CUSTOMER_LIST: auth+"/api/consumer/list",
  UPDATE_CUSTOMER_STATUS: auth+"/api/consumer/account/update",
  CUSTOMER_TRANSACTION_LIST: consumerService+"/api/report/transaction/admin",
  CUSTOMER_TRANSACTION_UPDATE: consumerService+"/api/report/transaction/update/status",
  CUSTOMER_TRANSACTION_REFUND: consumerService+"/payment/refund",
 
},
serviceManagement:{
  GET_SERVICES_LIST: financeService +"/api/service/list",
  GET_ASSIGN_SERVICES_LIST: financeService +"/api/manage/service/assigned/list",
  SERVICES_LIST_UPDATE: financeService +"/api/manage/service/permissions/update",
},
tenant:{
  GET_TENANT:tenantService+"/api/v1/admin/tenant/search?mobile=",
  GET_TENANT_DOC_APPROVE:tenantService+"/api/v1/admin/document/approve",
  GET_TENANT_UPDATE_STATUS:tenantService+"/api/v1/admin/tenant/update/status",
  TENANT_POLIC_VERIFICATION_UPLOAD:tenantService+"/api/v1/admin/document/upload",
  GET_TENANTLIST:  tenantService+"/api/v1/admin/tenant/list",
  GET_PGLIST:tenantService+"/api/v1/admin/accommodation/list",
  GET_MAPPING_LIST:tenantService+"/api/v1/admin/accommodation/mapping",
  ADD_PG:  tenantService+"/api/v1/admin/accommodation",
SAVE_ROOMS: tenantService+"/api/v1/admin/accommodation/room",
PG_LIST:tenantService+"/api/v1/admin/accommodation",
ROOM_DETAILS:tenantService+"/api/v1/admin/accommodation/rooms"
},
REPORT:{
   ANALYSE_UPLOAD: financeService +"/api/analyse/upload",
   ANALYSE_LIST: financeService +"/api/analyse/process-list",
   GET_ANALYSE_DETAILS: financeService +"/api/analyse/tidReport?",
   GET_TID_LIST: financeService +"/api/report/tid/report",
   GET_TXN_LOG: financeService +"/api/report/api/log",
},
OTHERS:{
  SETTLEMENT_URL:'/api/sendMoney/settlement'

}


};
